const getJsonFromBlob = async (blob: Blob) => {
    const text = await blob.text()
    return JSON.parse(text)
}

export const handleDownloadJson = async (blobs: Blob[]) => {
    const jsonObjects = await Promise.all(
        blobs.map((blob) => getJsonFromBlob(blob))
    )

    const jsonString = JSON.stringify(jsonObjects, null, 2)
    const blob = new Blob([jsonString], { type: 'application/json' })

    return blob
}
